function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { CoreVideoInternal } from '../../core-video-internal';
import { BasePlayerEngineItemPrecursor } from '../../core/player/player-engine-item-precursor';
import { PlayerType } from '../../core/player/player-type';
import { DrmType, DvrWindowDuration, StreamingProtocol } from '../../core/player/playout-data';
import { DrmNetworkFilter } from '../../drm/drm-network-filter';
import { CvsdkError, ErrorSeverity } from '../../error';
import { sdkLogger } from '../../logger';
import { isSafariDesktop, isIOSDevice } from '../../utils/device-type';
import { JsonUtils } from '../../utils/json-utils';
import { checkIsTizenVersion, DeviceType, TizenVersion } from '@sky-uk-ott/client-lib-js-device';
import { checkIsManifestLinearType, checkIsManifestVodType } from '../../utils/playback-type';
import { ManifestAdapter } from './dash-patch-mpd-adapter/manifest-adapter';
import { isVersionCompliant, MINIMUM_VERSION_FOR_UPSTREAM_PATCH } from './shaka-version-utils';
import { buildPlayerConfig } from './shaka-configuration-helper';
import { ShakaManifestPreprocessor } from './shaka-manifest-preprocessor';
import { ShakaPlayerEngineItemEventsManager } from './shaka-player-engine-item-events-manager';
import { ShakaPlayerError } from './shaka-player-error';
import { PSF_MIME_TYPE } from './psf/types';
var PLAYER_ELEMENT_ID = 'core-video-shaka';
var SAFARI_NATIVE_SUBTITLES_STYLE_ID = 'cvsdk-disabling-safari-native-subtitles';
var SAFARI_NATIVE_SUBTITLES_STYLE_CONTENT = 'video::-webkit-media-text-track-container { display: none; } video::-webkit-media-text-track-background { display: none; } video::-webkit-media-text-track-display { display: none; }';
export var ShakaPlayerEngineItemPrecursor = /*#__PURE__*/ function(BasePlayerEngineItemPrecursor) {
    "use strict";
    _inherits(ShakaPlayerEngineItemPrecursor, BasePlayerEngineItemPrecursor);
    function ShakaPlayerEngineItemPrecursor(capabilities, playoutData, playerConfig, advertBoltOns, drmBoltOns, supportsPreload, drmConfig, engineOptions) {
        _class_call_check(this, ShakaPlayerEngineItemPrecursor);
        var _this;
        var _this_playoutData_drmConfiguration, _propositionExtensions_propositionDrmConfig_drmType, _propositionExtensions_propositionDrmConfig;
        _this = _call_super(this, ShakaPlayerEngineItemPrecursor), _define_property(_this, "capabilities", void 0), _define_property(_this, "playoutData", void 0), _define_property(_this, "playerConfig", void 0), _define_property(_this, "advertBoltOns", void 0), _define_property(_this, "drmBoltOns", void 0), _define_property(_this, "supportsPreload", void 0), _define_property(_this, "drmConfig", void 0), _define_property(_this, "engineOptions", void 0), _define_property(_this, "logger", void 0), _define_property(_this, "player", void 0), _define_property(_this, "videoElement", void 0), _define_property(_this, "isSafari", void 0), _define_property(_this, "preloadManager", void 0), _define_property(_this, "fetched", void 0), _define_property(_this, "contentId", void 0), _define_property(_this, "errorContext", void 0), _define_property(_this, "isInternalRetryEnabled", void 0), _define_property(_this, "events", void 0), _define_property(_this, "drmNetworkFilter", void 0), _define_property(_this, "manifestPreProcessor", void 0), _define_property(_this, "onPlayerError", void 0), _define_property(_this, "attachPlayerEventListeners", void 0), /**
     * Attaches listeners, sets styles, etc.
     */ _define_property(_this, "preparePlayer", void 0), _define_property(_this, "requestFilter", void 0), _define_property(_this, "responseFilter", void 0), _this.capabilities = capabilities, _this.playoutData = playoutData, _this.playerConfig = playerConfig, _this.advertBoltOns = advertBoltOns, _this.drmBoltOns = drmBoltOns, _this.supportsPreload = supportsPreload, _this.drmConfig = drmConfig, _this.engineOptions = engineOptions, _this.logger = sdkLogger.withContext('ShakaPEIP'), _this.player = null, _this.videoElement = null, _this.fetched = false, _this.contentId = '', _this.errorContext = 'SDK.PEIP', _this.onPlayerError = function(error) {
            _this.onPlayErrorObservable.notifyObservers("".concat(error.toString()));
        }, _this.attachPlayerEventListeners = function() {
            var _this_player;
            (_this_player = _this.player) === null || _this_player === void 0 ? void 0 : _this_player.addEventListener('error', _this.onPlayerError);
        }, _this.preparePlayer = function() {
            _this.player = new shaka.Player();
            _this.events = new ShakaPlayerEngineItemEventsManager(_this.player);
            _this.attachPlayerEventListeners();
        }, _this.requestFilter = function(type, request) {
            if (type === shaka.net.NetworkingEngine.RequestType.LICENSE && request.body) {
                var buffer = 'buffer' in request.body ? request.body.buffer : request.body;
                request.body = _this.drmNetworkFilter.parseRequestBody(buffer, _this.contentId);
                var headers = {};
                var adaptedUris = [];
                if (_this.drmBoltOns.decorateLicenseRequest) {
                    request.uris.map(function(uri) {
                        var decoratedRequest = _this.drmBoltOns.decorateLicenseRequest({
                            url: uri,
                            method: request.method,
                            headers: request.headers,
                            body: request.body
                        });
                        if (decoratedRequest.credentials === 'include') {
                            request.allowCrossSiteCredentials = true;
                        }
                        /**
                     * Modifying just what should be modified because shaka request object is different than LicenseRequest
                     * If we modify as is done in bitmovin it will not work properly and the request will fail
                     */ Object.entries(decoratedRequest.headers).forEach(function(param) {
                            var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
                            headers[key] = value;
                        });
                        adaptedUris.push(decoratedRequest.url);
                    });
                }
                request.headers = Object.assign(headers, _this.drmNetworkFilter.getHeaders());
                if (adaptedUris.length) request.uris = adaptedUris;
                if (_this.checkDrmMatches(DrmType.PlayReady, DrmType.Widevine)) {
                    delete request.headers.SOAPAction;
                }
            }
        }, _this.responseFilter = function(type, response) {
            if (type === shaka.net.NetworkingEngine.RequestType.LICENSE) {
                response.data = _this.drmNetworkFilter.parseResponseBody(response.data);
            }
            if (type === shaka.net.NetworkingEngine.RequestType.MANIFEST) {
                var _this_events;
                (_this_events = _this.events) === null || _this_events === void 0 ? void 0 : _this_events.handleManifestAvailable();
            }
        };
        var deviceInfo = CoreVideoInternal.deviceInfo, deviceType = CoreVideoInternal.deviceType;
        _this.isSafari = isSafariDesktop(deviceInfo, deviceType);
        _this.isInternalRetryEnabled = ShakaPlayerEngineItemPrecursor.checkIsInternalRetryEnabled(_this.playoutData);
        if (_this.capabilities.preloadItems) {
            _this.preparePlayer();
        }
        var propositionExtensions = CoreVideoInternal.getPropositionExtensions();
        var drmType = (_this_playoutData_drmConfiguration = _this.playoutData.drmConfiguration) === null || _this_playoutData_drmConfiguration === void 0 ? void 0 : _this_playoutData_drmConfiguration.type;
        _this.drmNetworkFilter = new DrmNetworkFilter(drmType, propositionExtensions === null || propositionExtensions === void 0 ? void 0 : (_propositionExtensions_propositionDrmConfig = propositionExtensions.propositionDrmConfig) === null || _propositionExtensions_propositionDrmConfig === void 0 ? void 0 : (_propositionExtensions_propositionDrmConfig_drmType = _propositionExtensions_propositionDrmConfig[drmType]) === null || _propositionExtensions_propositionDrmConfig_drmType === void 0 ? void 0 : _propositionExtensions_propositionDrmConfig_drmType.provider, _this.logger);
        _this.manifestPreProcessor = new ShakaManifestPreprocessor(_this.handleManifestPreProcessorError.bind(_this));
        return _this;
    }
    _create_class(ShakaPlayerEngineItemPrecursor, [
        {
            key: "setEngineOptions",
            value: function setEngineOptions(engineOptions) {
                this.engineOptions = engineOptions;
            }
        },
        {
            key: "handleManifestPreProcessorError",
            value: function handleManifestPreProcessorError(p, error) {
                var _this_events;
                (_this_events = this.events) === null || _this_events === void 0 ? void 0 : _this_events.handleLoadingError(CvsdkError.from({
                    code: "".concat(this.errorContext, ".MANIFEST.CONTENT_WORKAROUND_FAILURE"),
                    message: 'Failure from manifest pre-processor "'.concat(p.label, '"'),
                    cause: error,
                    severity: p.isCritical ? ErrorSeverity.Fatal : ErrorSeverity.Warning
                }));
            }
        },
        {
            key: "tryApplyIpvrManifestPatches",
            value: function tryApplyIpvrManifestPatches(playerComponentConfig) {
                var _this_playoutData_cdns_, _this_playoutData;
                var patchAdapter = new ManifestAdapter((_this_playoutData = this.playoutData) === null || _this_playoutData === void 0 ? void 0 : (_this_playoutData_cdns_ = _this_playoutData.cdns[0]) === null || _this_playoutData_cdns_ === void 0 ? void 0 : _this_playoutData_cdns_.url);
                this.manifestPreProcessor.addProcessor({
                    label: 'infinitepvr',
                    isCritical: true,
                    callback: patchAdapter.patchMpdPreProcessor.bind(patchAdapter)
                });
                if (!isVersionCompliant(shaka.Player.version, MINIMUM_VERSION_FOR_UPSTREAM_PATCH)) {
                    playerComponentConfig.manifest.dash.enablePatchMPDSupport = true;
                }
                shaka.net.NetworkingEngine.registerScheme('patch', function(url, type) {
                    return patchAdapter.customPatchHandler(url, type);
                });
                return this.playoutData.cdns[0].originalUrl || this.playoutData.cdns[0].url;
            }
        },
        {
            key: "handlePreviouslyFetchedLoad",
            value: function handlePreviouslyFetchedLoad(player, autoplay) {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.preloadManager) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.createVideoElement(player)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    player.load(_this.preloadManager)
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                if (autoplay) {
                                    _this.attemptAutoplay();
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "doLoadWithConfig",
            value: function doLoadWithConfig(params) {
                var _this = this;
                return _async_to_generator(function() {
                    var error, _this_events, unifiedError;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    10,
                                    ,
                                    11
                                ]);
                                _this.fetched = true;
                                if (!_this.supportsPreload) return [
                                    3,
                                    6
                                ];
                                if (!params.isCalledFromPei) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.createVideoElement(params.player)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    params.player.load(params.loadUrl, params.startTime, params.mimeType)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                return [
                                    4,
                                    params.player.preload(params.loadUrl, params.startTime, params.mimeType)
                                ];
                            case 4:
                                _this.preloadManager = _state.sent();
                                _state.label = 5;
                            case 5:
                                return [
                                    3,
                                    9
                                ];
                            case 6:
                                return [
                                    4,
                                    _this.createVideoElement(params.player)
                                ];
                            case 7:
                                _state.sent();
                                return [
                                    4,
                                    params.player.load(params.loadUrl, params.startTime, params.mimeType)
                                ];
                            case 8:
                                _state.sent();
                                _state.label = 9;
                            case 9:
                                if (params.autoplay) {
                                    // Calling play here allows us to catch autoplay policy preventing playback
                                    _this.attemptAutoplay();
                                }
                                return [
                                    3,
                                    11
                                ];
                            case 10:
                                error = _state.sent();
                                _this.fetched = false;
                                unifiedError = ShakaPlayerError.playerLoadError({
                                    error: error
                                });
                                (_this_events = _this.events) === null || _this_events === void 0 ? void 0 : _this_events.handleLoadingError(unifiedError);
                                _this.onPlayErrorObservable.notifyObservers(error.toString());
                                return [
                                    3,
                                    11
                                ];
                            case 11:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "buildPlayerConfigFromPlayout",
            value: function buildPlayerConfigFromPlayout(playoutData, player) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this1, _this_playoutData_drmConfiguration, _this_playerConfig, _this_playerConfig1, _this_playerConfig2, _this_playerConfig3, _this_playerConfig4, _this_playerConfig5, _this_engineOptions, _this_playerConfig6, cert, securityBasedCapManager, maxResolution, _this_engineOptions_isMultiview;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getCert()
                                ];
                            case 1:
                                cert = _state.sent();
                                securityBasedCapManager = CoreVideoInternal.getPropositionExtensions().securityLevelBasedCapManager;
                                return [
                                    4,
                                    securityBasedCapManager === null || securityBasedCapManager === void 0 ? void 0 : securityBasedCapManager.getMaxResolution((_this_playoutData_drmConfiguration = _this.playoutData.drmConfiguration) === null || _this_playoutData_drmConfiguration === void 0 ? void 0 : _this_playoutData_drmConfiguration.type)
                                ];
                            case 2:
                                maxResolution = (_this1 = _state.sent()) === null || _this1 === void 0 ? void 0 : _this1.resolution;
                                return [
                                    2,
                                    buildPlayerConfig(playoutData, {
                                        certificate: cert,
                                        contentIdCallback: _this.handleContentIdAvailable.bind(_this),
                                        supportsCodecSwitching: _this.capabilities.supportsCodecSwitching,
                                        vptAbr: (_this_playerConfig = _this.playerConfig) === null || _this_playerConfig === void 0 ? void 0 : _this_playerConfig.vptAbr,
                                        manifestPreprocessor: _this.manifestPreProcessor.process.bind(_this.manifestPreProcessor),
                                        shakaTimeoutPolicy: (_this_playerConfig1 = _this.playerConfig) === null || _this_playerConfig1 === void 0 ? void 0 : _this_playerConfig1.shakaTimeoutPolicy,
                                        startAtSegmentBoundary: (_this_playerConfig2 = _this.playerConfig) === null || _this_playerConfig2 === void 0 ? void 0 : _this_playerConfig2.startAtSegmentBoundary,
                                        smoothCodecSwitch: (_this_playerConfig3 = _this.playerConfig) === null || _this_playerConfig3 === void 0 ? void 0 : _this_playerConfig3.smoothCodecSwitch,
                                        liveSync: (_this_playerConfig4 = _this.playerConfig) === null || _this_playerConfig4 === void 0 ? void 0 : _this_playerConfig4.liveSync,
                                        vodDynamicPlaybackRate: (_this_playerConfig5 = _this.playerConfig) === null || _this_playerConfig5 === void 0 ? void 0 : _this_playerConfig5.vodDynamicPlaybackRate,
                                        isMultiview: (_this_engineOptions_isMultiview = (_this_engineOptions = _this.engineOptions) === null || _this_engineOptions === void 0 ? void 0 : _this_engineOptions.isMultiview) !== null && _this_engineOptions_isMultiview !== void 0 ? _this_engineOptions_isMultiview : false,
                                        useMseOnSafari: (_this_playerConfig6 = _this.playerConfig) === null || _this_playerConfig6 === void 0 ? void 0 : _this_playerConfig6.useMseOnSafari,
                                        maxResolution: maxResolution
                                    }, player)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "load",
            value: function load(loadOptions) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_playoutData_cdns__streamInfo, _this_player_getNetworkingEngine, _this_player_getNetworkingEngine1, autoplay, playerComponentConfig, drmData, loadUrl, getAdaptedPlayoutStartPosition, startTime, mimeType;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.player) {
                                    _this.logger.warn('Player has been destroyed');
                                    return [
                                        2
                                    ];
                                }
                                autoplay = Boolean(loadOptions === null || loadOptions === void 0 ? void 0 : loadOptions.autoplay);
                                if (!_this.fetched) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.handlePreviouslyFetchedLoad(_this.player, autoplay)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    _this.buildPlayerConfigFromPlayout(_this.playoutData, _this.player)
                                ];
                            case 3:
                                playerComponentConfig = _state.sent();
                                drmData = !!_this.playoutData.drmConfiguration;
                                if (_this.isInternalRetryEnabled && drmData && playerComponentConfig.drm) {
                                    playerComponentConfig.drm.preserveMediaKeySessions = true;
                                }
                                loadUrl = _this.playoutData.cdns[0].url;
                                if (((_this_playoutData_cdns__streamInfo = _this.playoutData.cdns[0].streamInfo) === null || _this_playoutData_cdns__streamInfo === void 0 ? void 0 : _this_playoutData_cdns__streamInfo.windowDuration) === DvrWindowDuration.FullEvent) {
                                    loadUrl = _this.tryApplyIpvrManifestPatches(playerComponentConfig);
                                }
                                _this.logger.info("applying shaka configuration -> ".concat(JsonUtils.stringify(playerComponentConfig)));
                                _this.player.configure(playerComponentConfig);
                                (_this_player_getNetworkingEngine = _this.player.getNetworkingEngine()) === null || _this_player_getNetworkingEngine === void 0 ? void 0 : _this_player_getNetworkingEngine.registerRequestFilter(_this.requestFilter);
                                (_this_player_getNetworkingEngine1 = _this.player.getNetworkingEngine()) === null || _this_player_getNetworkingEngine1 === void 0 ? void 0 : _this_player_getNetworkingEngine1.registerResponseFilter(_this.responseFilter);
                                getAdaptedPlayoutStartPosition = function(playoutData) {
                                    var _CoreVideoInternal_config_default_addons_adInsertion, _CoreVideoInternal_config_default_addons, _CoreVideoInternal_config_default, _CoreVideoInternal_config, _CoreVideoInternal_config_default_addons_adInsertion_mediaTailor, _CoreVideoInternal_config_default_addons_adInsertion1, _CoreVideoInternal_config_default_addons1, _CoreVideoInternal_config_default1, _CoreVideoInternal_config1, _CoreVideoInternal_config_default_addons_adInsertion_adPolicyConfig, _CoreVideoInternal_config_default_addons_adInsertion2, _CoreVideoInternal_config_default_addons2, _CoreVideoInternal_config_default2, _CoreVideoInternal_config2;
                                    if (((_CoreVideoInternal_config = CoreVideoInternal.config) === null || _CoreVideoInternal_config === void 0 ? void 0 : (_CoreVideoInternal_config_default = _CoreVideoInternal_config.default) === null || _CoreVideoInternal_config_default === void 0 ? void 0 : (_CoreVideoInternal_config_default_addons = _CoreVideoInternal_config_default.addons) === null || _CoreVideoInternal_config_default_addons === void 0 ? void 0 : (_CoreVideoInternal_config_default_addons_adInsertion = _CoreVideoInternal_config_default_addons.adInsertion) === null || _CoreVideoInternal_config_default_addons_adInsertion === void 0 ? void 0 : _CoreVideoInternal_config_default_addons_adInsertion.enabled) && ((_CoreVideoInternal_config1 = CoreVideoInternal.config) === null || _CoreVideoInternal_config1 === void 0 ? void 0 : (_CoreVideoInternal_config_default1 = _CoreVideoInternal_config1.default) === null || _CoreVideoInternal_config_default1 === void 0 ? void 0 : (_CoreVideoInternal_config_default_addons1 = _CoreVideoInternal_config_default1.addons) === null || _CoreVideoInternal_config_default_addons1 === void 0 ? void 0 : (_CoreVideoInternal_config_default_addons_adInsertion1 = _CoreVideoInternal_config_default_addons1.adInsertion) === null || _CoreVideoInternal_config_default_addons_adInsertion1 === void 0 ? void 0 : (_CoreVideoInternal_config_default_addons_adInsertion_mediaTailor = _CoreVideoInternal_config_default_addons_adInsertion1.mediaTailor) === null || _CoreVideoInternal_config_default_addons_adInsertion_mediaTailor === void 0 ? void 0 : _CoreVideoInternal_config_default_addons_adInsertion_mediaTailor.deriveAdInfoFromManifest) && ((_CoreVideoInternal_config2 = CoreVideoInternal.config) === null || _CoreVideoInternal_config2 === void 0 ? void 0 : (_CoreVideoInternal_config_default2 = _CoreVideoInternal_config2.default) === null || _CoreVideoInternal_config_default2 === void 0 ? void 0 : (_CoreVideoInternal_config_default_addons2 = _CoreVideoInternal_config_default2.addons) === null || _CoreVideoInternal_config_default_addons2 === void 0 ? void 0 : (_CoreVideoInternal_config_default_addons_adInsertion2 = _CoreVideoInternal_config_default_addons2.adInsertion) === null || _CoreVideoInternal_config_default_addons_adInsertion2 === void 0 ? void 0 : (_CoreVideoInternal_config_default_addons_adInsertion_adPolicyConfig = _CoreVideoInternal_config_default_addons_adInsertion2.adPolicyConfig) === null || _CoreVideoInternal_config_default_addons_adInsertion_adPolicyConfig === void 0 ? void 0 : _CoreVideoInternal_config_default_addons_adInsertion_adPolicyConfig.alwaysForcePrerolls) && checkIsManifestVodType(playoutData.type)) {
                                        return 0;
                                    }
                                    return playoutData.position;
                                };
                                startTime = _this.getAdaptedStartTime(getAdaptedPlayoutStartPosition(_this.playoutData));
                                _this.logger.info("startTime -> ".concat(startTime));
                                _this.logger.info("loadUrl -> ".concat(loadUrl));
                                mimeType = _this.getMimeTypeFromProtocol(_this.playoutData.stream.protocol);
                                return [
                                    4,
                                    _this.doLoadWithConfig({
                                        player: _this.player,
                                        playerComponentConfig: playerComponentConfig,
                                        loadUrl: loadUrl,
                                        startTime: startTime,
                                        mimeType: mimeType,
                                        autoplay: autoplay,
                                        isCalledFromPei: loadOptions === null || loadOptions === void 0 ? void 0 : loadOptions.isCalledFromPei
                                    })
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "peiLoadStart",
            value: function peiLoadStart(handlers) {
                var _this_events;
                if (handlers.type !== PlayerType.Shaka) {
                    throw new Error("Incorrect handler type: ".concat(handlers.type, " but expected Shaka"));
                }
                if (!this.capabilities.preloadItems) {
                    this.preparePlayer();
                }
                if (!this.player) {
                    throw new Error('Missing player instance');
                }
                handlers.onPlayerAvailable(this.player, this.isInternalRetryEnabled);
                this.onPlayErrorObservable.registerObserver(handlers.onPlayError, this);
                (_this_events = this.events) === null || _this_events === void 0 ? void 0 : _this_events.attachPeiHandlers(handlers);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_player_getNetworkingEngine, _this_player, _this_player_getNetworkingEngine1, _this_player1, _this_events, _this_player2, _this_manifestPreProcessor;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (_this_player = _this.player) === null || _this_player === void 0 ? void 0 : (_this_player_getNetworkingEngine = _this_player.getNetworkingEngine()) === null || _this_player_getNetworkingEngine === void 0 ? void 0 : _this_player_getNetworkingEngine.unregisterRequestFilter(_this.requestFilter);
                                (_this_player1 = _this.player) === null || _this_player1 === void 0 ? void 0 : (_this_player_getNetworkingEngine1 = _this_player1.getNetworkingEngine()) === null || _this_player_getNetworkingEngine1 === void 0 ? void 0 : _this_player_getNetworkingEngine1.unregisterResponseFilter(_this.responseFilter);
                                (_this_events = _this.events) === null || _this_events === void 0 ? void 0 : _this_events.destroy();
                                _this.events = undefined;
                                return [
                                    4,
                                    (_this_player2 = _this.player) === null || _this_player2 === void 0 ? void 0 : _this_player2.destroy()
                                ];
                            case 1:
                                _state.sent();
                                _this.player = null;
                                (_this_manifestPreProcessor = _this.manifestPreProcessor) === null || _this_manifestPreProcessor === void 0 ? void 0 : _this_manifestPreProcessor.cleanup();
                                _this.onPlayErrorObservable.unregisterObservers(_this);
                                _this.fetched = false;
                                _this.videoElement = null;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createVideoElement",
            value: function createVideoElement(player) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_events;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.videoElement) {
                                    return [
                                        2
                                    ];
                                }
                                _this.videoElement = document.createElement('video');
                                _this.videoElement.id = PLAYER_ELEMENT_ID;
                                _this.setDefaultVideoStyle();
                                return [
                                    4,
                                    player.attach(_this.videoElement)
                                ];
                            case 1:
                                _state.sent();
                                (_this_events = _this.events) === null || _this_events === void 0 ? void 0 : _this_events.handleVideoCreated(_this.videoElement);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getMimeTypeFromProtocol",
            value: function getMimeTypeFromProtocol(protocol) {
                var mimeType = undefined;
                switch(protocol){
                    case StreamingProtocol.DASH:
                        mimeType = 'application/dash+xml';
                        break;
                    case StreamingProtocol.PDL:
                        mimeType = 'video/mp4';
                        break;
                    case StreamingProtocol.PSF:
                        mimeType = PSF_MIME_TYPE;
                        break;
                    default:
                        mimeType = undefined;
                }
                return mimeType;
            }
        },
        {
            key: "attemptAutoplay",
            value: function attemptAutoplay() {
                var _this = this;
                var _this_videoElement_play, _this_videoElement;
                (_this_videoElement = this.videoElement) === null || _this_videoElement === void 0 ? void 0 : (_this_videoElement_play = _this_videoElement.play()) === null || _this_videoElement_play === void 0 ? void 0 : _this_videoElement_play.catch(function(e) {
                    _this.onPlayErrorObservable.notifyObservers("".concat(e.name ? e.name + ': ' : '').concat(e.message));
                });
            }
        },
        {
            key: "getAdaptedStartTime",
            value: function getAdaptedStartTime(startTime) {
                var isVodManifest = checkIsManifestVodType(this.playoutData.type);
                // This is a hack for Tizen to be prevent a stall that can occur when the start position is 0
                // This Math.floor is necessary because of other Samsung workarounds. Code before this may set the startTime to ~0.01
                if (isVodManifest && CoreVideoInternal.deviceType === DeviceType.Tizen && !Math.floor(startTime || 0) && this.playoutData.stream.protocol !== StreamingProtocol.PDL) {
                    // Workaround for older Samsung models unable to start playback on unencrypted content
                    if (checkIsTizenVersion(CoreVideoInternal.deviceInfo, TizenVersion['Tizen-3']) && this.advertBoltOns.adBreakTimeAdapter) {
                        return this.advertBoltOns.adBreakTimeAdapter.contentTimeToTimeIncludingAds(0.1);
                    } else {
                        return 0.01;
                    }
                }
                var isLinearManifest = checkIsManifestLinearType(this.playoutData.type);
                if (isLinearManifest) {
                    var _this_playoutData = this.playoutData, linearPosition = _this_playoutData.linearPosition, stream = _this_playoutData.stream;
                    if (stream.protocol === StreamingProtocol.DASH && (linearPosition === null || linearPosition === void 0 ? void 0 : linearPosition.position)) {
                        return linearPosition.position;
                    }
                    if (stream.protocol === StreamingProtocol.HLS && (linearPosition === null || linearPosition === void 0 ? void 0 : linearPosition.position) && (linearPosition === null || linearPosition === void 0 ? void 0 : linearPosition.liveWindow)) {
                        return linearPosition.position - linearPosition.liveWindow.start;
                    }
                    return;
                }
                return startTime;
            }
        },
        {
            key: "handleContentIdAvailable",
            value: function handleContentIdAvailable(contentId) {
                this.contentId = contentId;
            }
        },
        {
            key: "getCert",
            value: function getCert() {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_playoutData_drmConfiguration, _this_drmConfig_widevine, _this_drmConfig, cert, _this_drmConfig_fairplay, _this_drmConfig1, certArrayBuffer, _this_drmConfig_fairplay1, _this_drmConfig2, req, _this_drmConfig_widevine1, _this_drmConfig3;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                cert = new Uint8Array();
                                if (!(((_this_playoutData_drmConfiguration = _this.playoutData.drmConfiguration) === null || _this_playoutData_drmConfiguration === void 0 ? void 0 : _this_playoutData_drmConfiguration.certificateUrl) && _this.checkDrmMatches(DrmType.Fairplay))) return [
                                    3,
                                    4
                                ];
                                certArrayBuffer = (_this_drmConfig1 = _this.drmConfig) === null || _this_drmConfig1 === void 0 ? void 0 : (_this_drmConfig_fairplay = _this_drmConfig1.fairplay) === null || _this_drmConfig_fairplay === void 0 ? void 0 : _this_drmConfig_fairplay.certificate;
                                if (!!certArrayBuffer) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    fetch(((_this_drmConfig2 = _this.drmConfig) === null || _this_drmConfig2 === void 0 ? void 0 : (_this_drmConfig_fairplay1 = _this_drmConfig2.fairplay) === null || _this_drmConfig_fairplay1 === void 0 ? void 0 : _this_drmConfig_fairplay1.certificateUrl) || _this.playoutData.drmConfiguration.certificateUrl)
                                ];
                            case 1:
                                req = _state.sent();
                                return [
                                    4,
                                    req.arrayBuffer()
                                ];
                            case 2:
                                certArrayBuffer = _state.sent();
                                _state.label = 3;
                            case 3:
                                cert = new Uint8Array(certArrayBuffer);
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                if (((_this_drmConfig = _this.drmConfig) === null || _this_drmConfig === void 0 ? void 0 : (_this_drmConfig_widevine = _this_drmConfig.widevine) === null || _this_drmConfig_widevine === void 0 ? void 0 : _this_drmConfig_widevine.certificate) && _this.checkDrmMatches(DrmType.Widevine)) {
                                    ;
                                    cert = new Uint8Array((_this_drmConfig3 = _this.drmConfig) === null || _this_drmConfig3 === void 0 ? void 0 : (_this_drmConfig_widevine1 = _this_drmConfig3.widevine) === null || _this_drmConfig_widevine1 === void 0 ? void 0 : _this_drmConfig_widevine1.certificate);
                                }
                                _state.label = 5;
                            case 5:
                                return [
                                    2,
                                    cert
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setDefaultVideoStyle",
            value: function setDefaultVideoStyle() {
                if (this.videoElement) {
                    this.videoElement.style.display = 'initial';
                    this.videoElement.style.width = '100%';
                    this.videoElement.style.height = '100%';
                    this.videoElement.style.zIndex = '-1';
                    this.videoElement.autoplay = false;
                    this.addPlaysInline(this.videoElement);
                }
                this.disableSafariNativeSubtitles();
            }
        },
        {
            key: "addPlaysInline",
            value: function addPlaysInline(element) {
                var deviceInfo = CoreVideoInternal.deviceInfo, deviceType = CoreVideoInternal.deviceType;
                if (isIOSDevice(deviceInfo, deviceType)) {
                    // any browser on iOS needs the plays in line
                    element.setAttribute('playsinline', '');
                }
            }
        },
        {
            key: "disableSafariNativeSubtitles",
            value: function disableSafariNativeSubtitles() {
                var disablingSafariNativeSubtitlesElement = document.getElementById(SAFARI_NATIVE_SUBTITLES_STYLE_ID);
                if (this.isSafari && !disablingSafariNativeSubtitlesElement) {
                    // Workaround to disable the native subtitle component on safari
                    // https://github.com/google/shaka-player/issues/2585
                    var style = document.createElement('style');
                    style.id = SAFARI_NATIVE_SUBTITLES_STYLE_ID;
                    style.innerHTML = SAFARI_NATIVE_SUBTITLES_STYLE_CONTENT;
                    document.getElementsByTagName('head')[0].appendChild(style);
                }
            }
        },
        {
            key: "checkDrmMatches",
            value: function checkDrmMatches() {
                for(var _len = arguments.length, drmTypes = new Array(_len), _key = 0; _key < _len; _key++){
                    drmTypes[_key] = arguments[_key];
                }
                var _this_playoutData_drmConfiguration, _this_playoutData;
                if ((_this_playoutData = this.playoutData) === null || _this_playoutData === void 0 ? void 0 : (_this_playoutData_drmConfiguration = _this_playoutData.drmConfiguration) === null || _this_playoutData_drmConfiguration === void 0 ? void 0 : _this_playoutData_drmConfiguration.type) {
                    return drmTypes.includes(this.playoutData.drmConfiguration.type);
                }
                return false;
            }
        }
    ], [
        {
            key: "checkIsInternalRetryEnabled",
            value: function checkIsInternalRetryEnabled(playoutData) {
                // return checkIsManifestLinearType(playoutData.type);
                // temporarily disabled until internal retry gets fixed
                return false;
            }
        }
    ]);
    return ShakaPlayerEngineItemPrecursor;
}(BasePlayerEngineItemPrecursor);

//# sourceMappingURL=shaka-player-engine-item-precursor.js.map